// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3Vrg-","info":"UpdateTermsInfo_info__3Bl7m"};